export enum CONTAINER_MAX_WIDTH {
  LG = 'lg',
  MD = 'md',
  SM = 'sm',
  XL = 'xl',
  XS = 'xs',
}
